module.exports = __webpack_public_path__ + "static/Persian-Style-Fetta-Classic-81adac93643cc74cdffc113b7974aca4.png";